import React, { Fragment } from 'react';
import classNames from 'classnames';

const NavMenu = (props) => {
  const { links, showMenu, toggleMenu } = props;

  const navClasses = classNames('nav-bar', {
    'nav-bar--show': showMenu,
    'nav-bar--close': showMenu === false
  });

  return links && links.length > 1 && <Fragment>
    <div className={classNames('hamburger-menu', { 'hamburger-menu--show': showMenu })}
        onClick={toggleMenu} />
      <nav className='nav-bar__container'>
        {
            <ul className={navClasses}>
            {
              links.map((link, idx) => (<li key={`nav-link-${idx}`} className='nav-link'>
                <a className={link.className} onClick={link.action} href={link.href}>{link.title}</a>
              </li>))
            }
          </ul>
        }
      </nav>
  </Fragment>;
};

export default NavMenu;

